import React from 'react';

interface ProductImageProps {
    image: string | null | undefined;
    name: string | null | undefined;
}

const ProductImage: React.FC<ProductImageProps> = ({ image, name }) => {
    return (
        <div className="product-image">
            <img src={image || "https://static.koreanmate.app/CizKAbQhDzmNHZuCuvMnnzVZWODqtemb/KIMHAJUN.png"} alt={name || "Product"} />
        </div>
    );
};

export default ProductImage;